module.exports = __webpack_public_path__ + "img/CED_yes-scene.285e3260.svg";